export default "<div class=\"card-footer\">\n    <ng-content></ng-content>\n</div>\n";